import { Hero } from "@/components/home/Hero";
import { Building, Marquee, RoomsBento } from "@/components/home/Sections";
import { FinalCta, Overhead } from "@/components/home/Overhead";
import { LatestNews } from "@/components/home/LatestNews";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Building />
      <RoomsBento />
      <LatestNews />
      <Overhead />
      <FinalCta />
    </main>
  );
}
